import { useFormContext } from 'react-hook-form';
import { User } from 'ts_shared';

const useUserFormContext = () => useFormContext<User>();

export default useUserFormContext;
